/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/order */
/* eslint-disable sort-imports */
/* tslint:disable:ordered-imports */
import '../../../styles/Ticker.scss';
import * as React from 'react';
import { Icon } from 'react-icons-kit';
import { NewsFormProps } from '../../claims/new/typings';
import { connect } from 'react-redux';
import { deactivateNewsFeed } from '../../../actions/update-claim';
import { getNewsFeed, submitNewNewsFeed } from '../../../actions/new-claim';
import { power, radio, send } from 'react-icons-kit/feather';
import { toast } from 'react-toastify';
import Ticker from '../Ticker';
import moment from 'moment';

interface NewsFeedPageProps extends NewsFormProps {
  auth?: {
    displayName?: string;
    email?: string;
  };
  onLogout: () => void;
}

interface RawNewsPayload {
  news?: {
    title?: string;
    news?: string;
  };
  origin?: string;
  _audit?: {
    created?: {
      timestamp?: any;
    };
  };
}

interface NewsItem {
  id: string;
  title: string;
  message: string;
  origin: string;
  createdOnLabel: string;
  createdOnEpoch: number;
}

const toEpoch = (timestamp: any): number => {
  if (!timestamp) {
    return 0;
  }
  if (typeof timestamp?.toDate === 'function') {
    return timestamp.toDate().getTime();
  }
  const date = new Date(timestamp);
  return Number.isNaN(date.getTime()) ? 0 : date.getTime();
};

const PostInput: React.FC<NewsFeedPageProps> = ({
  submitNewNewsFeed,
  getNewsFeed,
  deactivateNewsFeed,
  auth,
  onLogout,
}) => {
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [items, setItems] = React.useState<NewsItem[]>([]);

  const loadNewsFeeds = React.useCallback(async () => {
    try {
      const response: any = await getNewsFeed();
      const rows: Array<[RawNewsPayload, string]> = response?.newsFeedData?.data || [];
      const mapped: NewsItem[] = rows
        .map((row: any) => {
          const payload: RawNewsPayload = row && row[0] ? row[0] : {};
          const id = row && row[1] ? String(row[1]) : '';
          const createdOnEpoch = toEpoch(payload?._audit?.created?.timestamp);
          return {
            id,
            title: String(payload?.news?.title || 'Untitled'),
            message: String(payload?.news?.news || ''),
            origin: String(payload?.origin || 'Admin'),
            createdOnEpoch,
            createdOnLabel: createdOnEpoch ? moment(createdOnEpoch).format('DD/MM/YYYY') : '--/--/----',
          };
        })
        .filter((item: NewsItem) => item.id.length > 0)
        .sort((a: NewsItem, b: NewsItem) => b.createdOnEpoch - a.createdOnEpoch);

      setItems(mapped);
    } catch (error) {
      console.error(error);
      setItems([]);
    }
  }, [getNewsFeed]);

  React.useEffect(() => {
    loadNewsFeeds();
  }, [loadNewsFeeds]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!title.trim() || !message.trim()) {
      toast.error('Title and message are required.');
      return;
    }

    const payload: { news: { title: string; news: string } } = {
      news: {
        title: title.trim(),
        news: message.trim(),
      },
    };

    setLoading(true);
    submitNewNewsFeed(payload, async (err: Error) => {
      setLoading(false);
      if (err) {
        console.error(err);
        toast.error('Could not create news feed. Please try again later');
        return;
      }
      setTitle('');
      setMessage('');
      await loadNewsFeeds();
      toast.success('News published.');
    });
  };

  const handleReset = () => {
    setTitle('');
    setMessage('');
  };

  const handleDeactivate = (id: string) => {
    setLoading(true);
    deactivateNewsFeed(id, async (err: Error) => {
      setLoading(false);
      if (err) {
        console.error(err);
        toast.error('Could not deactivate news item. Please try again later');
        return;
      }
      await loadNewsFeeds();
      toast.success('News item deactivated.');
    });
  };

  const tickerItems = React.useMemo(() => {
    if (!items.length) {
      return [
        <div className="news-ticker-fallback" key="fallback-news">
          AGE announces new member updates.
        </div>,
      ];
    }

    return items.slice(0, 8).map((item: NewsItem) => {
      return (
        <div className="news-ticker-item" key={`news-${item.id}`}>
          <strong>{item.title}</strong>
          <span>{item.message}</span>
          <small>By {item.origin}</small>
        </div>
      );
    });
  }, [items]);

  const userLabel = auth?.displayName || auth?.email || '';

  return (
    <div className="news-layout-v2">
      <div className="news-user-strip-v2">
        <div className="news-user-label-v2">Hi, {userLabel}</div>
        <button className="news-user-logout-v2" onClick={onLogout} type="button" title="Logout">
          <Icon icon={power} size={18} />
        </button>
      </div>

      <div className="news-content-split-v2">
        <section className="create-news-pane-v2">
          <h1>Create News</h1>
          <span className="title-underline-v2" />

          <form onSubmit={handleSubmit}>
            <label htmlFor="news-title">Enter Title Here</label>
            <input
              id="news-title"
              value={title}
              onChange={(event) => setTitle(event.target.value)}
              type="text"
              disabled={loading}
            />

            <label htmlFor="news-message">Enter Message Here</label>
            <textarea
              id="news-message"
              value={message}
              onChange={(event) => setMessage(event.target.value)}
              disabled={loading}
            />

            <div className="news-form-actions-v2">
              <button type="button" className="btn-secondary-v2" onClick={handleReset} disabled={loading}>
                Reset
              </button>
              <button type="submit" className="btn-primary-v2" disabled={loading}>
                <Icon icon={send} size={16} />
                <span>{loading ? 'Sending...' : 'Send'}</span>
              </button>
            </div>
          </form>
        </section>

        <section className="previous-news-pane-v2">
          <h1>Previous News</h1>
          <span className="title-underline-v2" />

          <div className="previous-news-list-v2">
            {items.length ? (
              items.map((item: NewsItem) => (
                <div className="previous-news-item-v2" key={item.id}>
                  <div className="previous-news-icon-v2">
                    <Icon icon={radio} size={18} />
                  </div>
                  <div className="previous-news-copy-v2">
                    <div className="previous-news-date-v2">{item.createdOnLabel}</div>
                    <div className="previous-news-text-v2">{item.title} - {item.message}</div>
                  </div>
                  <button
                    className="previous-news-deactivate-v2"
                    onClick={() => handleDeactivate(item.id)}
                    disabled={loading}
                    type="button"
                  >
                    Deactivate
                  </button>
                </div>
              ))
            ) : (
              <div className="previous-news-empty-v2">No news available.</div>
            )}
          </div>
        </section>
      </div>

      <div className="breaking-news-bar-v2">
        <span className="breaking-news-badge-v2">Breaking News</span>
        <div className="breaking-news-ticker-v2">
          <Ticker isNewsTicker={true} slideSpeed={35}>
            {tickerItems.map((item, index) => (
              <div key={`ticker-${index}`} className="news-item">
                {item}
              </div>
            ))}
          </Ticker>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { submitNewNewsFeed, getNewsFeed, deactivateNewsFeed })(PostInput);
